import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { getCredentials } from '_store/credentials/slice';
import { getOrders } from '_store/orders/slice';
import { selectCustomerId } from '_store/user/selector';

import AddPaymentMethodModal from 'components/features/billing/AddPaymentMethodModal';
import CancelSubscriptionModal from 'components/features/billing/CancelSubscriptionModal';

const StyledContainer = styled.div``;

const PrivateLayout = () => {
  const dispatch = useDispatch();
  const customerId = useSelector(selectCustomerId);

  useEffect(() => {
    if (customerId) {
      dispatch(getCredentials({ customerId }));
      dispatch(getOrders({ customerId }));
    }
  }, [customerId]);

  return (
    <StyledContainer>
      <Outlet />
      <AddPaymentMethodModal />
      <CancelSubscriptionModal />
    </StyledContainer>
  );
};

export default PrivateLayout;
